import { CuteIcon } from '@/shared/components/CuteIcon'

export type HealthAccent = 'weight' | 'bodyFat' | 'sleep' | 'energy'

export function HealthIcon({ type }: { type: HealthAccent }) {
  return <CuteIcon name={type} />
}
